<template>
  <div
    id="m_quick_sidebar"
    class="m-quick-sidebar m-quick-sidebar--tabbed m-quick-sidebar--skin-light m-quick-sidebar--on"
  >
    <div class="m-quick-sidebar__content">
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
        v-if="pocId === 'add'"
      >
        <li class="nav-item m-tabs__item">
          <h5><span class="far fa-cabinet-filing"></span> Cadastro de POC</h5>
        </li>
      </ul>
      <ul
        id="m_quick_sidebar_tabs"
        class="nav nav-tabs m-tabs m-tabs-line m-tabs-line--brand"
        role="tablist"
        v-if="pocId > 0"
      >
        <li class="nav-item m-tabs__item">
          <h5><span class="far fa-cabinet-filing"></span> POC</h5>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane active" id="savePoc" role="tabpanel">
          <form name="customer" class="needs-validation" novalidate>
            <div
              id="alert"
              class="alert alert-dismissible fade show m-alert m-alert--outline mb-4 mt-4"
              :class="alert.color"
              role="alert"
              v-if="alert.message"
              ref="alert"
            >
              <button
                type="button"
                class="close"
                aria-label="Close"
                @click="alert.message = ''"
              ></button>
              <i :class="alert.icon"></i> &nbsp;<strong>{{ alert.message }}</strong
              ><br />
              {{ alert.reason }}
            </div>
            <div class="alert m-alert m-alert--default mb-3 mt-4" role="alert">
              <h5><i class="fas fa-info-circle"></i> Informações gerais</h5>
            </div>
            <div class="row">
              <div class="col-md-7">
                <div class="form-group" :class="{ 'has-danger': !data.customer_id }">
                  <label>Cliente <span v-if="!data.id" class="m--font-danger">*</span></label>
                  <div class="input-group">
                    <SelectCustomers
                      ref="customer_id"
                      :selected="data.customer_id"
                      :first="'Selecione um cliente'"
                      @change="updateCustomerIdValue"
                      :disabled="!!data.id"
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-5">
                <div class="form-group" :class="{ 'has-danger': !data.contract_id }">
                  <label>Contrato <span v-if="!data.id" class="m--font-danger">*</span></label>
                  <div class="input-group">
                    <SelectContracts
                      ref="contract_id"
                      :contractsSelect="contractsSelect"
                      :first="'Selecione um contrato'"
                      @change="updateContractId"
                      :selected="data.contract_id"
                      :disabled="!!data.id"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group" :class="{ 'has-danger': !data.start }">
                  <label for="start">Início da POC<span class="m--font-danger">*</span></label>
                  <div class="input-group">
                    <input
                      id="start"
                      type="date"
                      ref="start"
                      class="form-control m-input"
                      v-model="data.start"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div
                  class="form-group"
                  :class="{
                    'has-danger': !data.finish || (data.finish && data.start > data.finish),
                  }"
                >
                  <label for="finish">Fim da POC<span class="m--font-danger">*</span></label>
                  <div class="input-group">
                    <input
                      id="finish"
                      type="date"
                      ref="finish"
                      class="form-control m-input"
                      v-model="data.finish"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-12">
                <label for="notes">Observações</label>
                <div class="input-group">
                  <input
                    id="notes"
                    type="text"
                    class="form-control"
                    placeholder=""
                    v-model="data.notes"
                  />
                </div>
              </div>
            </div>
            <hr class="row mt-5 mb-3" />
            <div class="row">
              <div class="col-md-12 text-right">
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.customer_id.$el.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="!data.customer_id"
                    >O campo <strong>Cliente</strong> é obrigatório *</a
                  >
                </p>
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.contract_id.$el.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="!data.contract_id"
                    >O campo <strong>Contrato</strong> é obrigatório *</a
                  >
                </p>
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.start.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="!data.start"
                    >O campo <strong>Início do contrato</strong> é obrigatório *</a
                  >
                </p>
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.finish.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="!data.finish"
                    >O campo <strong>Fim do contrato</strong> é obrigatório *</a
                  >
                </p>
                <p class="p-0 m-0">
                  <a
                    href="#"
                    @click.prevent="$refs.finish.focus()"
                    target="_self"
                    class="m--font-danger"
                    v-if="data.finish && data.start > data.finish"
                    ><strong>Início do contrato</strong> não pode ser maior que o
                    <strong>Fim do contrato</strong></a
                  >
                </p>
              </div>
            </div>
            <div class="row mb-5">
              <div class="col-md-12 text-right">
                <button
                  @click.prevent="saveForm()"
                  class="btn"
                  :class="{
                    'btn-metal': !formIsValid,
                    'btn-focus': formIsValid,
                  }"
                  :disabled="!formIsValid || loading"
                >
                  <i class="fas fa-save" v-if="formIsValid"></i>
                  <i class="fas fa-exclamation-triangle" v-else></i>
                  Salvar
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SelectCustomers from '@/components/forms/SelectCustomers';
import SelectContracts from '@/components/forms/SelectContracts';
import { returnMessageFormMixin } from '@/mixins/returnMessageFormMixin.js';
import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  name: 'PocModal',
  mixins: [returnMessageFormMixin],
  components: { SelectCustomers, SelectContracts },
  data() {
    return {
      data: {
        customer_id: null,
        contract_id: null,
      },
      contractsSelect: [],
      loading: false,
      alert: {
        color: 'alert-primary',
        icon: 'fas fa-spinner fa-spin fa-lg',
        message: '',
        reason: '',
      },
    };
  },
  methods: {
    updateCustomerIdValue(customer_id) {
      axios(`${baseApiUrl}/v1/customer/contract/get-by-customer?customer_id=${customer_id}`).then(
        (res) => {
          this.data.customer_id = customer_id;
          this.contractsSelect = res.data;
        }
      );
    },
    updateContractId(contract_id) {
      this.data.contract_id = contract_id;
    },
    async saveForm() {
      await this.messageWaitingSave();

      const alertEl = this.$refs.alert;

      if (alertEl) {
        alertEl.scrollIntoView();
      }

      this.loading = true;

      const url = `${baseApiUrl}/v1/customer/pocs/save`;
      axios
        .post(url, this.data)
        .then((res) => {
          this.logMessageForm(res);
          this.$store.state.showPocSave = res.data.item.id;
          this.data.id = res.data.item.id;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.logMessageFormFailed(error.response);
        });
    },
    closeThis() {
      this.$emit('updateList');
      this.$store.state.showPocSave = null;
    },
    getPocToEdit(id) {
      const url = `${baseApiUrl}/v1/customer/pocs/data/${id}`;
      axios(url).then((res) => {
        this.data = res.data;
      });
    },
  },
  computed: {
    pocId() {
      return this.$store.state.showPocSave;
    },
    formIsValid() {
      if (
        this.data.customer_id &&
        this.data.contract_id &&
        this.data.start &&
        this.data.finish &&
        this.data.start < this.data.finish
      ) {
        return true;
      }
      return false;
    },
  },
  beforeMount() {
    if (this.pocId && this.pocId !== 'add') {
      this.getPocToEdit(this.pocId);
    }
  },
};
</script>
